module.exports = __webpack_public_path__ + "static/img/tc4.3d9913e.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/home/imgs/tc4.png
// module id = 9HGo
// module chunks = 1